import { SeasunDcLogger } from './seasundclogger/2.0.2';

class DcReporter {
  isInit = false;

  routeStartTime = 0;

  refresh() {
    this.routeStartTime = +new Date();
  }

  static instance = null;

  static getInstance(config) {
    if (!DcReporter.instance) {
      DcReporter.instance = new DcReporter(config);
    }
    return DcReporter.instance;
  }

  constructor(config) {
    this.init(config).finally(() => {
      this.isInit = true;
    });
  }

  getDiffRouteTime() {
    if (this.routeStartTime) {
      return +new Date() - this.routeStartTime;
    } else {
      return 0;
    }
  }

  /**
   *
   * @param config
   * @return {Promise<void>}
   */
  async init(config) {
    const customConfig = await this._createCustomConfig();
    SeasunDcLogger.config({
      ...config,
      commonAttributes: customConfig
    });
    window.addEventListener(
      'DOMContentLoaded',
      () => {
        this.refresh();
      },
      false
    );
    window.addEventListener(
      'hashchange',
      () => {
        this.refresh();
      },
      false
    );
    SeasunDcLogger.start();
  }

  delay(ms) {
    return new Promise(resolve => {
      setTimeout(() => resolve(), ms);
    });
  }

  async checkInit() {
    if (this.isInit) {
      return true;
    } else {
      await this.delay(200);
      return this.checkInit();
    }
  }

  createPushLog(log) {
    return {
      msgType: 'custom.event',
      accountId: '', //账号ID 确保全局唯一
      roleId: '', //角色ID
      roleName: '', //角色名
      roleType: '', //角色类型,如法师，道士，战士
      roleLevel: '', //角色等级
      roleVipLevel: '', //角色vip等级
      zone: '', //游戏区ID
      zoneName: '', //游戏区名称
      server: '', //游戏服ID,示例:s1,s2
      serverName: '', //游戏服名称,示例:风云争霸
      partyId: '', //公会ID
      gender: '', //角色性别 m:男 f:女
      battleScore: '', //战斗力
      eventId: '', //事件ID
      eventDesc: '', //事件描述
      eventBody: {}, //事件体
      ...log
    };
  }

  async push(log) {
    await this.checkInit();
    SeasunDcLogger.push(this.createPushLog(log));
  }

  getLocalTime(i) {
    if (typeof i !== 'number') return;

    const d = new Date();
    //得到1970年一月一日到现在的秒数
    const len = d.getTime();

    //本地时间与GMT时间的时间偏移差(注意：GMT这是UTC的民间名称。GMT=UTC）
    const offset = d.getTimezoneOffset() * 60000;

    //得到现在的格林尼治时间
    const utcTime = len + offset;

    return new Date(utcTime + 3600000 * i);
  }

  dateFormatter(fmt, date) {
    const o = {
      'M+': date.getMonth() + 1, //月份
      'd+': date.getDate(), //日
      'h+': date.getHours(), //小时
      'm+': date.getMinutes(), //分
      's+': date.getSeconds(), //秒
      'q+': Math.floor((date.getMonth() + 3) / 3), //季度
      S: date.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    for (let k in o)
      if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
    return fmt;
  }

  trackPageLoad() {
    window.addEventListener(
      'load',
      () => {
        this.pageLoad();
      },
      false
    );
  }

  pageLoad() {
    this.push({
      eventId: 'loadpageend', //事件ID
      eventDesc: '页面加载结束', //事件描述
      eventBody: {
        duration: this.getDiffRouteTime()
      } //事件体
    }).finally();
  }

  trackPageLeave(extra) {
    window.addEventListener(
      'beforeunload',
      () => {
        this.pageLeave(extra);
      },
      true
    );
  }

  pageLeave(extra) {
    this.push({
      eventId: 'leavepage', //事件ID
      eventDesc: '页面关闭', //事件描述
      eventBody: {} //事件体
    }).finally();
  }

  static async createCustomConfig() {
    return {};
  }
  async _createCustomConfig() {
    const extraConfig = await DcReporter.createCustomConfig();
    return {
      batchtimestamp: this.dateFormatter('yyyy-MM-dd hh:mm:ss.S', this.getLocalTime(8)),
      time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      reference: window.location.href,
      ...extraConfig
    };
  }
}

export default DcReporter;
